import { TrashIcon } from "assets";
import { SmallScreenModel } from "components";
import { useEffect, useState } from "react";
import HandleUpdateReadingMaterial from "./HandleUpdateReadingMaterial";
import HandleCreateReadingMaterial from "./HandleCreateReadingMaterial";
import { connect } from "react-redux";
import { fetchReadingMaterial } from "../store/action";
import { VideoDetailProps } from "modules/video/video_detail/store/actionType";
import HandleDeleteReadingMaterial from "./HandleDeleteReadingMaterial";
import { ReadingMaterialProps, stateStatusType } from "../store/actionType";
interface OwnProps {
  onClose: () => void;
  videoId: string;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & OwnProps;
const GetReadingMaterial: React.FC<Props> = ({
  onClose,
  readingMaterialState,
  onFetchRM,
  videoId,
}) => {
  const [openModel, setOpenModel] = useState(false);
  const [readingMaterial, SetReadingMaterial] = useState<ReadingMaterialProps | null>(null);

 useEffect(() => {
  if (videoId) {
    onFetchRM(videoId);
  }
}, [videoId, onFetchRM]);

useEffect(() => {
  if (readingMaterialState?.status === stateStatusType.SUCCESS) {
    SetReadingMaterial(readingMaterialState.readingMaterial);
  } else if (readingMaterialState?.status === stateStatusType.FAILED) {
    SetReadingMaterial(null);
  }
}, [readingMaterialState]);

  return (
    <>
      <div className="flex justify-between items-center px-4 py-2 bg-primary-500 text-white mb-2 rounded-md">
        <h3 className="text-lg font-semibold">Reading Material</h3>
        <div className="flex items-center justify-end gap-2">
          {!readingMaterial ||
          readingMaterial === null ? (
            <></>
          ) : (
            <div
              onClick={() => setOpenModel(true)}
              className="border px-2 py-1 rounded-md hover:border-red-500 text-white hover:text-red-500"
            >
              <TrashIcon className="size-4" />
            </div>
          )}

          {onClose && (
            <div className="border px-2 rounded-md hover:border-primary-300 text-white hover:text-primary-200">
              <button onClick={onClose} className="">
                ✕
              </button>
            </div>
          )}
          <SmallScreenModel setShowModal={setOpenModel} showModal={openModel}>
            <HandleDeleteReadingMaterial
              readingMaterial={readingMaterial}
              closeModal={() => setOpenModel(false)}
            />
          </SmallScreenModel>
        </div>
      </div>
      {!readingMaterial ||
      readingMaterial === null ? (
        <>
          <HandleCreateReadingMaterial
            videoId={videoId}
            onClose={onClose}
          />
        </>
      ) : (
        <HandleUpdateReadingMaterial
          rMData={readingMaterial}
          onClose={onClose}
          videoId={videoId}
        />
      )}
    </>
  );
};
const mapStateToProps = (state: any) => ({
  readingMaterialState: state.readingMaterial?.readingMaterialState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchRM: (video_id: string) => dispatch(fetchReadingMaterial(video_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GetReadingMaterial);
